import { Button, Container, FormGroup } from "reactstrap";
import { Component, Page } from "../../..";
import { useEffect, useState } from "react";
import { Api } from "../../../shared";
import { Tax } from "../../../shared/api";
import { App } from "../../App";
import { AddCountry, EditCountry } from "./EditCountry";
import { TaxList } from "./TaxList";
import { Card } from "../../../component";

type info_t = {
	taxes: Tax.TaxType[];
	countries: Tax.CountryType[];
};

export function Taxes() {

	let [info, setInfo] = useState<info_t | null>(null);
	
	const load_info = async () => {
		let res = await Api.Staff.Tax.Call.getAll({});
		if(res.data) {
			setInfo(res.data);
			return true;
		} else {
			throw res.error;
		}
	}

	useEffect(() => {load_info()}, []);

	if(!info) {
		return <Page.Staff></Page.Staff>;
	}

	let taxes_per_country: Record<string, Tax.TaxType[]> = {};
	for(let country of info.countries) {
		taxes_per_country[country.code] = [];
	}
	for(let tax of info.taxes) {
		taxes_per_country[tax.country].push(tax);
	}
	for(let country of info.countries) {
		for(let tax of taxes_per_country[country.code]) {
			tax.is_default = tax.id === country.tax_id;
		}
	}

	let countries_e: JSX.Element[] = [];
	let blocked_e: JSX.Element[] = [];
	
	const on_edit_country = (country: Tax.CountryType, taxes: Tax.TaxType[]) => {
		App.open(() => (
			<EditCountry taxes={taxes} country={country} on_save={load_info} />
		), false);
	}

	const add_country = () => {
		App.open(() => (
			<AddCountry on_save={load_info} />
		), false);
	}
	
	const on_save_tax = async (tax: Tax.TaxType) => {
		let res = await Api.Staff.Tax.Call.editTax({tax});
		if(!res.error) {
			return await load_info();
		} else {
			throw res.error;
		}
	}

	const on_delete_tax = async (tax: Tax.TaxType) => {
		if(tax.id === null) {
			return false;
		}
		let ask = await App.openDialogue({
			title: `Delete ${tax.label} (${info?.countries[tax.id]?.label})?`,
			prompt: true,
			content: () => <>
				<p>Are you sure you want to delete this tax? This action cannot be undone.</p>
			</>,
		});
		if(!ask) {
			return false;
		}
		let res = await Api.Staff.Tax.Call.deleteTax({tax_id: tax.id, country: tax.country});
		if(res.error) {
			throw res.error;
		}
		return await load_info();
	}
	
	for(let country of info.countries) {
		if(country.code === "AU") {
			continue;
		}
		
		let taxes = taxes_per_country[country.code];

		countries_e.push(<TaxList
			country={country}
			taxes={taxes_per_country[country.code]}
			on_edit_country={() => on_edit_country(country, taxes)}
			on_save_tax={on_save_tax}
			on_delete_tax={on_delete_tax}
		/>);
	}

	return (
		<Page.Staff>
			<Container>
				<h4>International Taxes</h4>
				{countries_e}
				<Button onClick={add_country}>Add Country</Button>
			</Container>
		</Page.Staff>
	);
}

